import React from 'react';

import ColorItem from 'onboarding/common/colorPicker/ColorItem';

function ColorMenu(props) {
  return (
    <div className="rounded-border-wrap">
      <div className="flex-container">
        {props.items.map((item) => (
          <div key={item.hex}>
            <ColorItem info={item} isSelected={props.activeItem.hex === item.hex} makeActive={props.makeActive} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default ColorMenu;
